
























import { Component, Prop, Mixins } from 'vue-property-decorator'
  import BaseVue from '@/mixins/BaseVue'
  import { CMMF } from '@/services/connecteur'
  import codeFormat from '@/filters/cmmfCodeFormat'

  @Component({
    filters: { codeFormat }
  })
  export default class TemplateItemCMMF extends Mixins(BaseVue) {
    @Prop({ required: true })
    public item!: CMMF
  }
